import { v4 as uuidv4 } from "uuid";
import { createRichTextProp } from "@/react/components/shared/BuilderUI/DefaultBlocks/utils/richTextHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import {
  getColorOptions,
  getFontSizeOptions,
  getFontStyleOptions,
  getFontWeightOptions,
  getLineHeightOptions,
  getTextAlignOptions,
  getTextDecorationOptions,
  getTextTransformOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { p3DefaultStyles as defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "p",
  props: {
    text: createRichTextProp("Paragraph text"),
    paragraphStyle: {
      prop: "other",
      type: "paragraph-style-picker",
      value: "p3",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        textTransform: getTextTransformOptions(defaultStyles.textTransform),
        fontStyle: getFontStyleOptions(defaultStyles.fontStyle),
        fontSize: getFontSizeOptions(defaultStyles.fontSize),
        textAlign: getTextAlignOptions(defaultStyles.textAlign),
        textDecoration: getTextDecorationOptions(defaultStyles.textDecoration),
        lineHeight: getLineHeightOptions(defaultStyles.lineHeight),
        color: getColorOptions(defaultStyles.color),
        fontWeight: getFontWeightOptions(defaultStyles.fontWeight),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
      },
    },
  },
};
